import Link from 'next/link';
import React from 'react';
import { FaAngleDown, FaRegUser } from 'react-icons/fa';
import { IoClose } from 'react-icons/io5';

import Image from 'next/image';
import { FaArrowLeft } from 'react-icons/fa6';
import HeaderCart from './HeaderCart';
import HeaderHomeLink from './HeaderHomeLink';
import HeaderPageLink from './HeaderPageLink';
import Script from 'next/script';
import TrkSearch from './TrkSearch';

const Header = () => {
  return (
    <>
      <Script src="/js/trk-menu.js" />
      <header className="header">
        <div className="container">
          <div className="header__wrapper">
            <div className="header__brand">
              <Link href="/">
                <Image
                  width={172}
                  height={48}
                  src="/images/logo/logo.svg"
                  alt="logo"
                />
              </Link>
            </div>
            {/* section navbar Menu */}
            <div className="header__navbar">
              <div className="header__overlay" />
              <nav className="menu">
                <div className="menu-mobile-header">
                  <button type="button" className="menu-mobile-arrow">
                    <FaArrowLeft />
                  </button>
                  <div className="menu-mobile-title" />
                  <button type="button" className="menu-mobile-close">
                    <IoClose />
                  </button>
                </div>
                <ul className="menu-section">
                  <li className="menu-item-has-children">
                    <Link href="#">
                      Home <FaAngleDown />
                    </Link>
                    <div className="submenu">
                      <HeaderHomeLink />
                    </div>
                  </li>
                  <li>
                    <Link href="/flash-sale">Flash Sale</Link>
                  </li>
                  <li className="menu-item-has-children">
                    <Link href="#">
                      Pages <FaAngleDown />
                    </Link>
                    <div className="submenu megamenu">
                      <h6 className="megamenu__title mb-3">Megamenu</h6>
                      <HeaderPageLink />
                    </div>
                  </li>
                  <li className="menu-item-has-children">
                    <Link href="/shop">Shop</Link>
                  </li>
                  <li>
                    <Link href="/contact">Contact</Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="header__action">
              <Link
                className="header__action-btn d-none d-xl-grid"
                href="/login"
                aria-label="Login"
              >
                <FaRegUser />
              </Link>

              <HeaderCart />
              <TrkSearch />
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
